import PropTypes from 'prop-types';
import React from 'react';

import { isPropTypeNullable } from '../../../utils/prop-types';
import t from '../../../labels/labelling-utils';
import { MatchPhase } from '../../../typings/match';
import { IReportsHomeMatch, MatchReportStatusList } from '../../../typings/match-reports';
import MatchDataRow from '../../atoms/match-data-row/match-data-row';
import MatchTableHead from '../../atoms/match-table-head/match-table-head';
import MatchCtaRow from '../../molecules/match-cta-row/match-cta-row';
import MatchRow from '../../molecules/match-row/match-row';
import { IClassNames, makeClassNames } from '../../../utils/styles';

import './reports-home-table.scss';

export interface IReportsHomeTable {
  reportsDetailsUrl?: string;
  matchList: Array<IReportsHomeMatch>;
  round: string | number;
  competitionPhase?: MatchPhase; // FIXME: REAL BE data has COMPETITIONPHASE here -> we use it the correct way?
}

const classNames = (): IClassNames =>
  makeClassNames({
    reportsHomeTable: 'reports-home-table',
  });

const ReportsHomeTable: React.FC<IReportsHomeTable> = ({ reportsDetailsUrl, matchList, round }) => {
  const cn = classNames();

  return (
    <React.Fragment>
      <table className={cn.reportsHomeTable}>
        <MatchTableHead />
        <tbody>
          <MatchDataRow title={String(round)} />
          {matchList.map((match: IReportsHomeMatch) => (
            <MatchRow
              {...match}
              label={match.statusLabel}
              link={match.reportUrl || ''}
              key={match.id ?? match.matchId}
              cta={t('reports.view.match.votes')}
              type="results"
              linkArialabel={`Vai alle pagelle di ${match.home.name} - ${match.away.name}`}
            />
          ))}
          {reportsDetailsUrl && <MatchCtaRow href={reportsDetailsUrl}>{t('reports.view.all.match.votes')}</MatchCtaRow>}
        </tbody>
      </table>
    </React.Fragment>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  ReportsHomeTable.propTypes = {
    matchList: PropTypes.arrayOf(
      PropTypes.shape({
        ...MatchRow.propTypes!,
        referees: PropTypes.arrayOf(
          PropTypes.shape({
            fullname: PropTypes.string,
            id: PropTypes.number.isRequired,
            name: PropTypes.string,
            surname: PropTypes.string,
          }).isRequired
        ).isRequired,
        reportStatus: PropTypes.oneOf(MatchReportStatusList),
        reportUrl: isPropTypeNullable(PropTypes.string),
        roundName: isPropTypeNullable(PropTypes.string),
      }).isRequired
    ).isRequired,
    reportsDetailsUrl: PropTypes.string,
    round: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };
}

export default ReportsHomeTable;
